export default {
  SET_SIZE_CHART(state, value) {
    state.size_chart = value
  },
}
